/* Ela Teila — model line under the main product photo. */
(function () {
  var DOGS = {
    black: "10.2 in / 26 cm back, 7.1 in / 18 cm neck, 11.4 in / 29 cm chest",
    white: "9.8 in / 25 cm back, 6.7 in / 17 cm neck, 10.6 in / 27 cm chest",
    brown: "12.6 in / 32 cm back, 7.1 in / 18 cm neck, 12.6 in / 32 cm chest"
  };

  function dogOf(alt) {
    var a = (alt || "").toLowerCase();
    if (!a) return null;
    var b = a.replace(/dog (blanket|blankets|collar|collars|lead|leads|leash|leashes|bed|beds|harness|bow|bows|jumper|coat|jacket|sweater|snood|scarf|bandana|clothes|toy)/g, "");
    if (!/\bdog\b|dog's|puppy/.test(b)) return null;
    if (/\bwhite dog\b/.test(a)) return "white";
    if (/\bbrown dog\b/.test(a)) return "brown";
    if (/\bblack dog\b/.test(a)) return "black";
    if (/curly|apricot|poodle/.test(a)) return "brown";
    if (/black and tan|dark dog|dark coat|black coat/.test(a)) return "black";
    if (/cream dog|pale-haired dog|pale dog|long-haired/.test(a)) return "white";
    return null;
  }
  function A(e) { return (e.getAttribute("alt") || e.getAttribute("aria-label") || "").trim(); }

  function stripStatic() {
    var info = document.querySelector(".product__info");
    if (!info) return;
    var ps = info.querySelectorAll("p");
    for (var i = 0; i < ps.length; i++) {
      if (/^\s*model\s*:/i.test(ps[i].textContent)) { ps[i].remove(); }
    }
  }

  function run() {
    var pm = document.querySelector("product-media, .product__media");
    if (!pm) return;
    stripStatic();

    if (!document.getElementById("et-fit-style")) {
      var st = document.createElement("style");
      st.id = "et-fit-style";
      st.textContent = ".et-fit-line{font-family:'Roboto Condensed',sans-serif;font-size:14px;letter-spacing:0.5px;color:#6B7480;text-align:center;line-height:1.5;margin:14px 0 0;}@media screen and (min-width:741px){.et-fit-line{position:absolute;left:0;right:0;top:100%;}}";
      document.head.appendChild(st);
    }

    var list = pm.querySelector(".product__media-list") || pm;
    var items = [].slice.call(list.querySelectorAll(".product__media-item"));
    if (!items.length) {
      items = [].slice.call(list.querySelectorAll("img,video")).map(function (m) { return m.closest(".product__media-item") || m; });
    }
    function mediaOf(it) { return (it.matches && it.matches("img,video")) ? it : it.querySelector("img,video"); }
    if (!items.some(function (it) { var m = mediaOf(it); return m && dogOf(A(m)); })) return;

    var wrap = pm.querySelector(".product__media-list-wrapper") || list.parentElement || pm;
    var line = document.getElementById("et-fit-line");
    if (!line) {
      line = document.createElement("div");
      line.id = "et-fit-line";
      line.className = "et-fit-line";
      wrap.appendChild(line);
    }

    function activeItem() {
      var sel = items.filter(function (it) { return it.classList && (it.classList.contains("is-selected") || it.classList.contains("is-active") || it.classList.contains("is-current")); });
      if (sel.length) return sel[0];
      var vis = items.filter(function (it) {
        if (it.getAttribute && it.getAttribute("aria-hidden") === "true") return false;
        var m = mediaOf(it) || it, r = m.getBoundingClientRect();
        return r.width > 2 && r.height > 2;
      });
      return vis[0] || items[0];
    }
    function draw() {
      stripStatic();
      var it = activeItem(), m = it ? mediaOf(it) : null, d = m ? dogOf(A(m)) : null;
      if (d && DOGS[d]) { line.textContent = "Model: " + DOGS[d] + "."; line.style.display = ""; }
      else { line.style.display = "none"; }
    }
    var raf;
    function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }

    draw();
    new MutationObserver(schedule).observe(list, { attributes: true, subtree: true, attributeFilter: ["class", "aria-hidden"] });
    document.addEventListener("click", function () { setTimeout(draw, 60); setTimeout(draw, 350); }, true);
    window.addEventListener("resize", schedule);
  }
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();

/* Ela Teila — product tiles: "View details" instead of quick buy. */
(function () {
  function label(root) {
    var items = (root || document).querySelectorAll(".product-item");
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var link = it.querySelector("a.product-item__aspect-ratio") || it.querySelector("a.product-item-meta__title");
      if (!link) continue;
      var href = link.getAttribute("href");
      if (!href) continue;
      var extras = it.querySelectorAll(".drawer--quick-buy, .popover--quick-buy");
      for (var k = 0; k < extras.length; k++) { extras[k].remove(); }
      var btns = it.querySelectorAll(".product-item__quick-buy-button");
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        if (b.getAttribute("data-et-cta")) continue;
        b.removeAttribute("is");
        b.removeAttribute("aria-controls");
        var c = b.cloneNode(true);
        c.setAttribute("data-et-cta", href);
        c.setAttribute("type", "button");
        if (b.parentNode) b.parentNode.replaceChild(c, b);
        var t = c.querySelector(".loader-button__text") || c;
        t.textContent = (window.etTileCtaLabel || "View details");
        c.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = this.getAttribute("data-et-cta");
        }, true);
      }
    }
  }
  function init() {
    label(document);
    if (window.MutationObserver) {
      new MutationObserver(function () { label(document); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

/* Ela Teila - HOOKAS virs nuotraukos, MOBILE ONLY (<= 999px).
 * Imam dali IKI PIRMO <br> - daugelyje sablonu hookas ir specifikaciju
 * sarasas yra vienoje pastraipoje. Originalas issaugomas data-et-orig. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  var BR = /<br\s*\/?>/i;

  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }
  function stripLeadingBr(html) { return html.replace(/^(?:\s|<br\s*\/?>|&nbsp;)+/i, ""); }

  function apply() {
    var product = document.querySelector(".product");
    if (!product) return;
    var media = product.querySelector("product-media, .product__media");
    var src = product.querySelector(".product__info .product-form__text:not(:last-child) > p:first-child");
    var existing = product.querySelector(".et-hook");

    if (!src) { if (existing) existing.remove(); return; }

    if (!isMobile()) {
      if (existing) existing.remove();
      if (src.hasAttribute("data-et-orig")) {
        src.innerHTML = src.getAttribute("data-et-orig");
        src.removeAttribute("data-et-orig");
      }
      return;
    }

    if (!media) { if (existing) existing.remove(); return; }

    var orig = src.hasAttribute("data-et-orig") ? src.getAttribute("data-et-orig") : src.innerHTML;
    var parts = orig.split(BR);
    var head = parts[0].trim();
    var rest = stripLeadingBr(parts.slice(1).join("<br>"));

    var probe = document.createElement("div");
    probe.innerHTML = head;
    if (!probe.textContent || !probe.textContent.trim()) { if (existing) existing.remove(); return; }

    if (!existing) {
      existing = document.createElement("p");
      existing.className = "et-hook";
      media.parentNode.insertBefore(existing, media);
    }
    if (existing.innerHTML !== head) { existing.innerHTML = head; }
    if (!src.hasAttribute("data-et-orig")) { src.setAttribute("data-et-orig", orig); }
    if (src.innerHTML !== rest) { src.innerHTML = rest; }
  }

  if (document.readyState !== "loading") apply();
  else document.addEventListener("DOMContentLoaded", apply);
  if (mq && mq.addEventListener) mq.addEventListener("change", apply);
  else window.addEventListener("resize", apply);
})();

/* Ela Teila - SIZE CHART i spalvu eilute, MOBILE ONLY. Perkeliam, ne
 * kopijuojam - tai toggle-button su aria-controls. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function apply() {
    var form = document.querySelector(".product__info .product-form");
    if (!form) return;
    var colors = form.querySelector(".et-color-switch");
    var link = form.querySelector(".product-form__option-link");
    var info = link ? link.closest(".product-form__option-info") : null;
    var slot = colors ? colors.querySelector(".et-size-chart-slot") : null;

    if (!isMobile()) {
      if (info && info.etHome && info.etHome.parentNode && info.parentNode !== info.etHome.parentNode) {
        info.classList.remove("et-size-chart-moved");
        info.etHome.parentNode.insertBefore(info, info.etHome.nextSibling);
      }
      if (slot) slot.parentNode.removeChild(slot);
      return;
    }

    if (!colors || !info) return;
    if (slot && info.parentNode === slot) return;

    if (!slot) {
      slot = document.createElement("span");
      slot.className = "et-size-chart-slot";
      colors.appendChild(slot);
    }
    while (slot.firstChild) { slot.removeChild(slot.firstChild); }

    if (!info.etHome) {
      info.etHome = document.createComment("et-size-chart-home");
      info.parentNode.insertBefore(info.etHome, info);
    }
    info.classList.add("et-size-chart-moved");
    slot.appendChild(info);
  }

  if (document.readyState !== "loading") apply();
  else document.addEventListener("DOMContentLoaded", apply);
  if (mq && mq.addEventListener) mq.addEventListener("change", apply);
  else window.addEventListener("resize", apply);
  document.addEventListener("click", function () { setTimeout(apply, 60); setTimeout(apply, 350); }, true);
})();

/* Ela Teila - spalvu eilute lygiuojama i DYDZIU JUOSTA, MOBILE ONLY. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function bandWidth(el) {
    var kids = el.children;
    if (!kids || !kids.length) return 0;
    var first = kids[0].getBoundingClientRect();
    var last = kids[kids.length - 1].getBoundingClientRect();
    return Math.round(Math.max(first.right, last.right) - Math.min(first.left, last.left));
  }

  function apply() {
    var form = document.querySelector(".product__info .product-form");
    if (!form) return;
    var colors = form.querySelector(".et-color-switch");
    if (!colors) return;
    if (!isMobile()) { colors.style.width = ""; return; }

    var sizes = form.querySelector(".product-form__variants .block-swatch-list")
             || form.querySelector(".product-form__variants .select-wrapper");
    if (!sizes) { colors.style.width = ""; return; }

    var w = bandWidth(sizes);
    if (w > 40) { colors.style.width = w + "px"; }
  }

  function schedule() { requestAnimationFrame(apply); }

  if (document.readyState !== "loading") schedule();
  else document.addEventListener("DOMContentLoaded", schedule);
  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule);
  if (mq && mq.addEventListener) mq.addEventListener("change", schedule);
  document.addEventListener("click", function () { setTimeout(apply, 60); setTimeout(apply, 350); }, true);
})();

/* Ela Teila - trust eilute i VIENA eilute, MOBILE ONLY. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  var SEP = /\s*[·•]\s*/;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function apply() {
    var form = document.querySelector(".product__info .product-form");
    if (!form) return;
    var blocks = form.querySelectorAll(".product-form__text");
    if (!blocks.length) return;
    var p = blocks[blocks.length - 1].querySelector("p");
    if (!p) return;

    if (!p.hasAttribute("data-et-full")) { p.setAttribute("data-et-full", p.textContent); }
    var full = p.getAttribute("data-et-full");

    if (!isMobile()) { if (p.textContent !== full) { p.textContent = full; } return; }

    var parts = full.split(SEP).filter(function (s) { return s.trim().length; });
    if (parts.length < 3) return;
    /* 2026-09-29: telefone rodom PIRMAS DVI dalis (pvz. "Ships in 1-2 business days · No duties"),
       nes visos trys netelpa. Anksciau buvo pirma + paskutine. */
    var wanted = parts[0].trim() + " · " + parts[1].trim();
    if (p.textContent !== wanted) { p.textContent = wanted; }
  }

  if (document.readyState !== "loading") apply();
  else document.addEventListener("DOMContentLoaded", apply);
  if (mq && mq.addEventListener) mq.addEventListener("change", apply);
  else window.addEventListener("resize", apply);
})();

/* Ela Teila - SHARE kainos eiluteje, MOBILE ONLY.
 * Rita: Share turi buti KAINOS eiluteje, desineje. Kaina lygiuojasi su kairiu
 * nuotraukos krastu, Share - su desiniu.
 *
 * Keliam ji I PATI kainos bloka (.product-meta__price-list-container), o ne
 * segam koordinatemis - tada jis lieka su kaina VISADA, net kai pavadinimas
 * luzta i dvi eilutes (o su ilgais pavadinimais tai nutinka).
 * Jokiu fiksuotu px reiksmiu.
 *
 * Grazinimui isimenam tikslia vieta JS kintamajame, ne DOM atribute. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  var home = null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function apply() {
    var product = document.querySelector(".product");
    if (!product) return;
    var aside = product.querySelector(".product-meta__aside");
    if (!aside) return;
    var target = product.querySelector(".product-meta__price-list-container");
    if (!target) return;

    if (isMobile()) {
      if (aside.parentNode !== target) {
        if (!home) { home = { parent: aside.parentNode, next: aside.nextSibling }; }
        target.insertBefore(aside, target.firstChild);
      }
      return;
    }

    if (home && aside.parentNode !== home.parent) {
      home.parent.insertBefore(aside, home.next);
    }
  }

  if (document.readyState !== "loading") apply();
  else document.addEventListener("DOMContentLoaded", apply);
  if (mq && mq.addEventListener) mq.addEventListener("change", apply);
  else window.addEventListener("resize", apply);
  document.addEventListener("click", function () { setTimeout(apply, 60); }, true);
})();

/* Ela Teila - ATSILIEPIMU GALERIJA pries TABUS, MOBILE ONLY.
 * Kodel JS, o ne CSS order: tai dvi atskiros sekcijos, tiesioginiai #main
 * vaikai. Kad veiktu order, #main tektu paversti flex konteineriu, o tai
 * isjungtu parasciu sutrauka tarp VISU sekciju. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  var home = null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function apply() {
    var main = document.getElementById("main");
    if (!main) return;
    var content = main.querySelector('[id*="__product-content"]');
    var gallery = main.querySelector('[id*="__gallery"]');
    if (!content || !gallery) return;

    if (isMobile()) {
      if (gallery.nextElementSibling !== content) {
        if (!home) { home = { parent: gallery.parentNode, next: gallery.nextSibling }; }
        content.parentNode.insertBefore(gallery, content);
      }
      return;
    }

    if (home && gallery.nextSibling !== home.next) {
      home.parent.insertBefore(gallery, home.next);
    }
  }

  if (document.readyState !== "loading") apply();
  else document.addEventListener("DOMContentLoaded", apply);
  if (mq && mq.addEventListener) mq.addEventListener("change", apply);
  else window.addEventListener("resize", apply);
})();

/* Ela Teila - TABAI uzdaryti is pradziu, MOBILE ONLY.
 * Description atidarytas is anksto uzima ~120px. Naudojam .click() ant temos
 * paties perjungimo mygtuko, kad pasikeistu ir aria-expanded, ir rodykle.
 * Veikia TIK VIENA KARTA per uzkrovima. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  var done = false;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }

  function apply() {
    if (done || !isMobile()) return;
    var t = document.querySelector('.product-tabs__tab-item-wrapper .collapsible-toggle[aria-expanded="true"]');
    if (!t) return;
    done = true;
    t.click();
  }

  if (document.readyState !== "loading") setTimeout(apply, 0);
  else document.addEventListener("DOMContentLoaded", function () { setTimeout(apply, 0); });
  window.addEventListener("load", apply);
})();

/* Ela Teila - SPALVOS NESOKINEJA keiciant dydi, MOBILE ONLY (2026-09-24).
 * Paspaudus dydi tema is naujo perpiesia pirkimo forma. Size chart nuoroda
 * ir spalvu eilutes plotis anksciau atsistatydavo tik po 60 ms (click
 * setTimeout), todel ratukai kelis kadrus persokdavo i centra ir atgal.
 * MutationObserver suveikia IS KARTO po DOM pakeitimo, dar pries ekrano
 * atnaujinima, todel suoliuko nebelieka. Logika ta pati kaip auksciau. */
(function () {
  var mq = window.matchMedia ? window.matchMedia("(max-width: 999px)") : null;
  function isMobile() { return mq ? mq.matches : (window.innerWidth <= 999); }
  var busy = false;

  function fix() {
    if (busy || !isMobile()) return;
    var form = document.querySelector(".product__info .product-form");
    if (!form) return;
    var colors = form.querySelector(".et-color-switch");
    if (!colors) return;
    busy = true;
    try {
      var link = form.querySelector(".product-form__option-link");
      var info = link ? link.closest(".product-form__option-info") : null;
      var slot = colors.querySelector(".et-size-chart-slot");
      if (info && !(slot && info.parentNode === slot)) {
        if (!slot) {
          slot = document.createElement("span");
          slot.className = "et-size-chart-slot";
          colors.appendChild(slot);
        }
        while (slot.firstChild) { slot.removeChild(slot.firstChild); }
        if (!info.etHome) {
          info.etHome = document.createComment("et-size-chart-home");
          info.parentNode.insertBefore(info.etHome, info);
        }
        info.classList.add("et-size-chart-moved");
        slot.appendChild(info);
      }
      if (!colors.style.width) {
        var sizes = form.querySelector(".product-form__variants .block-swatch-list")
                 || form.querySelector(".product-form__variants .select-wrapper");
        if (sizes && sizes.children.length) {
          var a = sizes.children[0].getBoundingClientRect();
          var b = sizes.children[sizes.children.length - 1].getBoundingClientRect();
          var w = Math.round(Math.max(a.right, b.right) - Math.min(a.left, b.left));
          if (w > 40) { colors.style.width = w + "px"; }
        }
      }
    } finally { busy = false; }
  }

  function init() {
    var info = document.querySelector(".product__info");
    if (!info || !window.MutationObserver) return;
    new MutationObserver(fix).observe(info, { childList: true, subtree: true });
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
